export function formatDateApi(date: Date): string {
  return date.toISOString().split('T')[0];
}

export function formatDateLocal(date: Date): string {
  return date.toLocaleDateString('cs-CZ', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  });
}

export function formatDateLocalFixed(date: Date): string {
  return date.toLocaleDateString('cs-CZ', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function parseIsoDate(dateString: string): Date {
  return new Date(dateString);
}
